/**
 * With email confirmation ON, Supabase anti-enumeration makes `signUp` on an already-registered,
 * CONFIRMED email answer with a fake success: a user object with an EMPTY `identities` array, no
 * session, and no email sent. Left undetected, the screen shows "check your inbox" and nothing ever
 * arrives. A genuinely new account carries its email identity (length 1), and an existing but
 * UNCONFIRMED account also does — for that one Supabase re-sends the confirmation email, so the
 * inbox screen is right and it must NOT trip this predicate. Mirrors the mobile app's
 * `features/auth/model/existingEmailSignUp.ts`, because the two clients must fail identically.
 */

/** Structural subset of supabase-js's `signUp` response data. */
export interface SignUpData {
  user: { identities?: unknown[] | null } | null;
  session: object | null;
}

/** True when `signUp` "succeeded" for an email that already has a confirmed account. */
export function isExistingEmailSignUp(data: SignUpData): boolean {
  return data.session === null && data.user?.identities?.length === 0;
}
